import { jsx } from 'react/jsx-runtime';
import { getIntegrationConfig } from '../../../connections/connections.config.js';
import { IconEditorial30FolderImgSrc, IconEditorial16FolderImgSrc, IconEditorial24FolderImgSrc, IconEditorial48FolderImgSrc, IconEditorial30FolderImg, IconEditorial16FolderImg, IconEditorial24FolderImg, IconEditorial48FolderImg } from '@fabric-app/icons/svg';
import { RootType } from '@fabric/woody-client';
import { styled } from 'styled-components';

const predefinedIconMap = {
  "fabric-folder": {
    Icon: {
      48: IconEditorial48FolderImg,
      24: IconEditorial24FolderImg,
      16: IconEditorial16FolderImg,
      30: IconEditorial30FolderImg
    },
    src: {
      48: IconEditorial48FolderImgSrc,
      24: IconEditorial24FolderImgSrc,
      16: IconEditorial16FolderImgSrc,
      30: IconEditorial30FolderImgSrc
    }
  }
};
const sizeToIntegrationConfigIcon = {
  48: "IconCardStore",
  24: "IconSidebar",
  16: "IconPath",
  30: "IconCardPreview"
};
const DEFAULT_SIZE = 48;
const renderResourceIcon = (args, options) => {
  if (typeof args === "string") {
    const icon2 = predefinedIconMap[args];
    const Icon = icon2.Icon[options?.size || 48];
    return /* @__PURE__ */ jsx(Icon, {});
  }
  const { icon, root, id } = args;
  if (!icon) {
    if (root && root.type === RootType.INTEGRATION) {
      if (root.folder.id === id) {
        const viewConfig = getIntegrationConfig(root.subtype);
        if (viewConfig) {
          const Icon2 = viewConfig[sizeToIntegrationConfigIcon[options?.size || DEFAULT_SIZE]];
          if (Icon2) {
            return /* @__PURE__ */ jsx(Icon2, {});
          }
        }
      }
    }
    const icon2 = predefinedIconMap["fabric-folder"];
    const Icon = icon2.Icon[options?.size || DEFAULT_SIZE];
    return /* @__PURE__ */ jsx(Icon, {});
  }
  if (icon.type === "emoji") {
    return icon.emoji;
  }
  if (icon.type === "customImage") {
    return /* @__PURE__ */ jsx(Img, {
      alt: "icon",
      src: icon.customImage.url
    });
  }
  if (icon.type === "predefined" && predefinedIconMap) {
    const predefinedIcon = predefinedIconMap[icon.predefined];
    if (!predefinedIcon) {
      return null;
    }
    const Icon = predefinedIcon.Icon[options?.size || DEFAULT_SIZE];
    return /* @__PURE__ */ jsx(Icon, {});
  }
  return null;
};
const Img = styled.img.withConfig({
  displayName: "renderResourceIcon__Img",
  componentId: "sc-b48f926a-0"
})([
  `width:1em;height:1em;object-fit:contain;`
]);

export { predefinedIconMap, renderResourceIcon };
//# sourceMappingURL=renderResourceIcon.js.map
